"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NativeTokenDialogForm = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const mui_inputs_draft_1 = require("@dzambalaorg/mui-inputs-draft");
const types_1 = require("@framework/types");
const mui_inputs_entity_1 = require("@dzambalaorg/mui-inputs-entity");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const dialogs_1 = require("../../../../../dialogs");
const types_2 = require("../../../../../types");
const NativeTokenDialogForm = (props) => {
    const { open, mode, service } = props;
    // to create token use office
    if (mode === "create" && service !== types_2.ServiceType.OFFICE && process.env.BUSINESS_TYPE === types_1.BusinessType.B2B) {
        return (0, jsx_runtime_1.jsx)(dialogs_1.UpgradeProductTypeDialog, { open: open });
    }
    const columns = {
        [types_2.ServiceType.ADMIN]: mode === "edit" ? [3, 1] : [2, 1],
        [types_2.ServiceType.OFFICE]: mode === "edit" ? [2, 2, 1] : [3, 1],
    };
    return ((0, jsx_runtime_1.jsxs)(ui_kit_1.FormGrid, { columns: columns[service], children: [(0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: "title", required: true }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: "symbol", required: true }), service === types_2.ServiceType.OFFICE && (0, jsx_runtime_1.jsx)(mui_inputs_entity_1.EntityInput, { name: "merchantId", controller: "merchants" }), mode === "edit" && ((0, jsx_runtime_1.jsx)(mui_inputs_core_1.SelectInput, { name: "contractStatus", options: types_1.ContractStatus, disabledOptions: [types_1.ContractStatus.NEW] })), (0, jsx_runtime_1.jsx)(mui_inputs_draft_1.RichTextEditor, { name: "description", required: true })] }));
};
exports.NativeTokenDialogForm = NativeTokenDialogForm;
//# sourceMappingURL=index.js.map